export const surveyDict = {
    en: {
      "Surveys": "Surveys",
      "S.No": "S.No",
      "Name": "Name",
      "Status": "Status",
      "Points": "Points",
      "Expire Date": "Expire Date",
      "Starts": "Starts",
      "Action": "Start Survey",
      "Click Here to start survey": "Click Here to start survey",
      "Pending": "Pending",
      "Terminated": "Terminated",
      "Quality Terminate": "Quality Terminate",
      "Completed": "Completed",
      "Disqualified": "Disqualified",
      "No Data Available": "No data is available"
    },
    hi: {
      "Surveys": "सर्वे",
      "S.No": "क्र.सं.",
      "Name": "नाम",
      "Status": "स्थिति",
      "Points": "पॉइंट",
      "Expire Date": "समाप्त होने की तिथि",
      "Starts": "प्रारंभ होगा",
      "Action": "सर्वे शुरू करें",
      "Click Here to start survey": "सर्वे शुरू करने के लिए यहां क्लिक करें",
      "Pending": "लंबित",
      "Terminated": "समाप्त",
      "Quality Terminate": "गुणवत्ता समाप्ति",
      "Completed": "पुरा होना।",
      "Disqualified": "विच्छेदित",
      "No Data Available": "फिलहाल डेटा उपलब्ध नहीं है."
    },
    jp: {
      "Surveys": "アンケート",
      "S.No": "番号",
      "Name": "名前",
      "Status": "ステータス",
      "Points": "ポイント",
      "Expire Date": "有効期限",
      "Starts": "開始",
      "Action": "アンケート開始",
      "Click Here to start survey": "アンケートを開始するにはここをクリック",
      "Pending": "保留中",
      "Terminated": "終了",
      "Quality Terminate": "品質終了",
      "Completed": "完了",
      "Disqualified": "対象外",
      "No Data Available": "データはありません"
    }
  };

  // Panelist-facing derived survey-status labels. Keys match the backend
  // shared helper (utils/surveyStatus.js -> deriveSurveyStatus statusKey),
  // so the My Surveys table Status column and the helper never drift.
  export const surveyStatusLabels = {
    en: {
      complete: "Complete",
      incomplete: "Incomplete",
      notStarted: "Not Started",
      pending: "Pending",
      expired: "Expired",
      onHold: "On Hold",
      closed: "Closed",
      terminated: "Terminated",
      overQuota: "Over Quota",
      qualityTerminated: "Quality Terminated"
    },
    hi: {
      complete: "पूर्ण",
      incomplete: "अधूरा",
      notStarted: "शुरू नहीं हुआ",
      pending: "लंबित",
      expired: "समाप्त",
      onHold: "होल्ड पर",
      closed: "बंद",
      terminated: "समाप्त किया गया",
      overQuota: "कोटा पूर्ण",
      qualityTerminated: "गुणवत्ता समाप्त"
    },
    jp: {
      complete: "完了",
      incomplete: "未完了",
      notStarted: "未着手",
      pending: "保留中",
      expired: "期限切れ",
      onHold: "保留中",
      closed: "終了",
      terminated: "終了",
      overQuota: "定員超過",
      qualityTerminated: "品質終了"
    }
  };

  export const panelistDetailsDict = {
    en: {
      "Panelist Details": "Panelist Details",
      "Survey Name": "Survey Name",
      "Expiry Date": "Expiry Date",
      "Status": "Status",
      "Description": "Description"
    },
    hi: {
      "Panelist Details": "पैनलिस्ट विवरण",
      "Survey Name": "सर्वे का नाम",
      "Expiry Date": "समाप्ति तिथि",
      "Status": "स्थिति",
      "Description": "विवरण"
    },
    jp: {
      "Panelist Details": "パネリスト詳細",
      "Survey Name": "アンケート名",
      "Expiry Date": "有効期限",
      "Status": "ステータス",
      "Description": "説明"
    }
  };
